import { FLIGHT_OVERVIEW_NAME, FLIGHT_OVERVIEW_SIZE } from '@vakantiesnl/components/src/molecules/FlightTransfer';
import { containerFrom } from '@vakantiesnl/components/src/styles/container';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	flightsContainer: {
		containerType: 'inline-size',
		containerName: FLIGHT_OVERVIEW_NAME,
	},

	flights: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,

		[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
			gap: theme.spacing.medium,
		},
	},
}));
